module.exports = __webpack_public_path__ + "static/media/cn.5f897860.webp";